/**
 * Context + hook for the guided-tour engine. Lives apart from the provider
 * component so Fast Refresh / react-refresh lint stays happy.
 */
import { createContext, useContext } from 'react'
import type { TourStep } from '@/lib/tours/types'

export interface TourContextValue {
  isRunning: boolean
  currentStep: TourStep | null
  stepIndex: number
  stepCount: number
  hasNextSection: boolean
  /** Start (or resume) a tour by id. */
  startTour: (tourId: string) => void
  next: () => void
  back: () => void
  skipSection: () => void
  /** End the run; `dismissed` keeps it resumable, `completed` marks it done. */
  endTour: (outcome?: 'dismissed' | 'completed') => void
}

export const TourContext = createContext<TourContextValue | null>(null)

export function useTour(): TourContextValue {
  const ctx = useContext(TourContext)
  if (!ctx) throw new Error('useTour must be used within TourProvider')
  return ctx
}
